<template>
    <section class="catalog-section-wrapper b-rabbit" :class="{'px-0' : suggestions && !blackRabbit}" :data-qa-total="total">
        <MuffinLoader 
            v-if="isLoading"
            class="full-page"
        />
        <Suggestions
            v-if="suggestions && !isMobile"
            :suggestions-data="suggestions"
            :isBlackRabbit="true"
            :blocks-url="siteBlock"
            :home-url="homeUrl"
            :class="{'d-none' : !domCss}"
        />
        <Campaigns 
            v-if="!expiredCampaign && campaignData && !isMobile"
            :campaign-data="campaignData"
            :isBlackRabbit="true"
            :class="{'d-none' : !domCss}"
        />
        <CampaignsMobile
            v-if="!expiredCampaign && campaignData && isMobile"
            :campaign-data="campaignData"
        />
        <Tabs v-if="tabs" :items="tabs" @tabClicked="tabClicked" :isMobile="isMobile"/>
        <FilterDashboard
            v-if="!isMobile && !expiredCampaign && !emptyListMessage && (!suggestions && filterData)"
            :filter-data="filterData"
            :sort-data="sortData"
            :isClub="clubMode"
            @updateCatalog="loadBackend"
            @searchListText="debounceSearch"
            :class="{'d-none' : !domCss}"
        />
        <List
            v-if="!isMobile && !expiredCampaign && (!suggestions && products)"
            :products="products"
            :list-title="catalogTitle"
            :is-club="clubMode"
            @updateCatalog="loadBackend"
            @clearSearchBar="getSearchResults(null)"
            :class="{'d-none' : !domCss}"
        />
        <ListMobile
            v-if="isMobile && !expiredCampaign && (suggestions || products)"
            :products="products"
            :list-title="catalogTitle"
            :filter-data="filterData"
            :sort-data="sortData"
            :is-club="clubMode"
            :suggestions-data="suggestions"
            @updateCatalog="loadBackend"
            :blocks-url="siteBlock"
            :class="{'has-campaigns' : campaignData}"
        />
        <div v-if="emptyListMessage && !suggestions" class="empty-list-msg">
            <h2>{{ emptyListMessage }}</h2>
            <button class="catalog-button" @click="goToHome">{{ kStrings.kBACK_TO_HOMEPAGE }}</button>
        </div>
    </section>
</template>

<script>

import {store} from '@/store/catalog';
import VueScrollTo from 'vue-scrollto';
import apiCatalog from '@/api/catalog';
import utilities from '@/Utilities/common';

import {isEmpty, debounce} from 'lodash-es';
import homeUtils from '@/Utilities/homeUtils';
import MuffinLoader from '@/components/Muffin/Loader';

export default {
    store,
    name: 'Index',
    components: {
        MuffinLoader,
        List: () => import('@/components/Catalog/Desktop/sections/List.vue'),
        ListMobile: () => import('@/components/Catalog/Mobile/sections/List.vue'),
        Campaigns: () => import('@/components/Catalog/Desktop/sections/Campaigns.vue'),
        Suggestions: () => import('@/components/Catalog/Desktop/sections/Suggestions.vue'),
        CampaignsMobile: () => import('@/components/Catalog/Mobile/sections/Campaigns/Campaigns.vue'),
        FilterDashboard: () => import('@/components/Catalog/Desktop/sections/Filters/FilterDashboard.vue'),
        Tabs: () => import('@/components/Catalog/Common/Tabs.vue'),
    },
    props: {
        catalogData: null,
        expiredCampaign: null,
        isMobile: false,
        textSearch: null,
        isBlackRabbit: true,
        total:0,
        isClub: false,
    },
    data() {
        return {
            domCss: false,
            bRabbit: true,
            clubMode: false,
            //tabs: null,
            recordType: null,
        }
    },
    computed: {
        siteBlock(){
            return this.catalogData?.urls?.siteBlock ?? undefined;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        storeBackup() {
            return this.$store.getters.storeBackup; 
        },
        isLoading() {
            return this.$store.getters.isLoading;
        },
        campaignData() {
            const data = this.$store.getters.campaigns;
            return !isEmpty(data) ? data : null;
        },
        catalogTitle() {
            return this.$store.getters.catalogTitle;
        },
        searchListText() {
            return this.$store.getters.searchListText;
        },
        filterData() {
            const data = this.$store.getters.filters;
            return !isEmpty(data) ? data : null;
        },
        products() {
            const data = this.$store.getters.products;
            return !isEmpty(data) ? data : null;
        },
        tabs() {
            const data = this.$store.getters.tabs;
            return data && data.length ? data : null;
        },
        sortData() {
            const data = this.$store.getters.sorts;
            return !isEmpty(data) ? data : null;
        },
        suggestions() {
            const data = this.$store.getters.suggestions;
            return !isEmpty(data) ? data : null;
        },
        urls() {
            return this.$store.getters.urls;
        },
        emptyListMessage(){
            return this.$store.getters.extras.emptyListMessage;
        },
        blackRabbit(){
            return this.bRabbit;
        },
        homeUrl(){
            return this.$store.getters.urls.home;
        },
        isTextSearch(){
            return this.$store.getters.extras.isTextSearch;
        },
    },
    watch: {
        expiredCampaign(){
            this.setupView();
        },
        catalogData(){
            this.setupView();
        }
    },
    //beforeCreate() {},
    //created() {},
    mounted() {        
        this.$nextTick(() => {
            if(this.isMobile && this.textSearch){
                this.$store.dispatch('setSearchListText', this.textSearch);
            }
            this.$store.dispatch('setLoading', true);
            this.setupView();
            if(this.expiredCampaign) {
                window.removeEventListener("resize", this.resize);
                window.addEventListener("resize", this.resize);
                setTimeout(() => {
                    this.resize();
                }, 150);
            }
        });

        this.clubMode = this.isClub;
        if(this.isMobile && this.isClub && this.textSearch){
            // prozis club search
            window.addEventListener("popstate", (event) => {
                // reload page to update component (mobile search page loads diferent components if has/doesn't have text)
                window.location.reload();
            });
        }

        this.bRabbit = this.isBlackRabbit;
        this.positionOnPage();
        if(!this.isMobile){
            window.addEventListener('popstate', this.onPopstate);
        }
    },
    methods: {
        async setupView() {
            if(this.expiredCampaign) {
                //console.log('expired campaign mode: ', this.expiredCampaign.props);
                this.setExpiredCampaign(this.expiredCampaign.props);
                this.$store.dispatch('setStoreBackup', this.expiredCampaign.props);
                this.$store.dispatch('setExpiredCampaign', true);
            } else {
                if (!(typeof this.catalogData === 'undefined' || this.catalogData === null) && !isEmpty(this.catalogData)) {
                    //console.log('normal list mode: ', this.catalogData);
                    this.$store.dispatch('setStoreBackup', this.catalogData); // backup main view list
                    this.loadBackend(this.catalogData);

                } else if (this.storeBackup) {
                    //console.log('restore store backup!', this.storeBackup);

                    if(this.$store.getters.expiredCampaign) {
                        //console.log('restore store expired campaign!', this.storeBackup);
                        this.setExpiredCampaign(this.storeBackup);
                    } else {
                        this.loadBackend(this.storeBackup);
                    }
                }
            }
        },
        async loadBackend(data) {
            if(data.componentsCss != null){
                await this.$store.dispatch('setComponentsCss', data.componentsCss);
            }
            if(data?.kStrings??null){
                await this.$store.dispatch('setKStrings', data.kStrings);
            }
            if(data?.urls??null){
                await this.$store.dispatch('setUrls', data.urls);
            }

            //this.tabs = null;   // reset tabs
            if(data?.wsData??null){
                await this.$store.dispatch('setWsData', data.wsData);
                //this.tabs =data.wsData.tabs && data.wsData.tabs.length ? data.wsData.tabs : this.tabs;
            }
            if(this.expiredCampaign) {
                await this.domCssObserver();
            } else {
                this.domCss = true;
                this.$store.dispatch('setLoading', false);
            }
            this.clubMode = data.isClub ? data.isClub : this.clubMode;
        },
        async setExpiredCampaign(data) {
            if(data && data.componentsCss != null){
                await this.$store.dispatch('setComponentsCss', data.componentsCss);
            }
            if(data?.urls??null){
                await this.$store.dispatch('setUrls', data.urls);
            }
            if(data?.suggestions??null){
                await this.$store.dispatch('setSuggestions', data.suggestions);
            }
            await this.domCssObserver();
            //await this.$store.dispatch('setLoading', false);
        },
        // setSearchListText(text) {
        //     this.$store.dispatch('setSearchListText', text);
        // }, 
        debounceSearch: debounce(function(text){
            this.getSearchResults(text);
        }, 500),
        async getSearchResults(text){
            let url = null;
            // copy object so that original is kept intact
            let params = this.urls.baseParams ? JSON.parse(JSON.stringify(this.urls.baseParams)) : {};
            if(!text || text.length > 2){
                //console.log('search text: adding text param');
                url = this.urls.baseUrl
                params.text = text;
                params.rtype = this.recordType;
            }
            //console.log('search text', text, url, params);
            if(url){
                this.$store.dispatch('setLoading', true);
                const {data} = await apiCatalog.backendRequest(url, null, params);
                if(data && data.hasOwnProperty('catalogData')) {
                    //console.log('text ', text);
                    this.$store.dispatch('setSearchListText', text);
                    this.loadBackend(data.catalogData);
                }
                this.$store.dispatch('setLoading', false);
            }
        },        
        async domCssObserver() {
            let catalogCss = document.getElementById('catalogCss');
            let homeCss = document.getElementById('homeCss');

            let observer = new MutationObserver((mutations) => {
                if (catalogCss && homeCss || this.domCss) {
                    this.domCss = true;
                    this.$store.dispatch('setLoading', false);
                    observer.disconnect();
                }
            });

            // Start observing
            observer.observe(document.documentElement, { //document.body is node target to observe
                attributes: true, childList: true, subtree: true,
            });

            // if metatags observer fails ...
            setTimeout(() => {
                this.domCss = true;
                this.$store.dispatch('setLoading', false);
                observer.disconnect();
            }, 200);
        },
        resize() {
            homeUtils.setPropertyVW();
        },
        goToHome() {
            window.location.href = this.$store.getters.urls.home;
        },
        tabClicked(item){
            // if(this.isMobile){
            //     this.recordType = item.type;
            //     this.getSearchResults(this.textSearch);
            // }
            // else{
            if(!item.selected){
                this.$store.dispatch('setLoading', true);
                document.location.href = item.url;
            }
            // }
        },
        positionOnPage(){
            let current = null;
            if(utilities.storageAvailable("sessionStorage")) { 
                let anchor = sessionStorage.getItem('catalogAnchor');
                if(anchor){
                    // remove it from storage
                    sessionStorage.removeItem('catalogAnchor');
                    anchor = JSON.parse(anchor);
                    current = (anchor && anchor.url && anchor.url == window.location.href) ? anchor.groupId : current;
                }
            }
            if (current) {
                setTimeout(() => {
                    const productToAnchor =  document.querySelector(".prz-blk-product-item[data-id='"+current+"']");
                    if(productToAnchor){
                        VueScrollTo.scrollTo(productToAnchor, 500, {
                            container: 'body',
                            easing: 'linear',
                            offset: -100,
                            x: false,
                            y: true
                        });
                    }
                }, 500);
            }
        },
        onPopstate(event){
            if(event.state && event.state.refresh === true){
                window.location.reload();
            }
        },
    },
};
</script>

<style lang="scss">

.catalog-section-wrapper {
    button {
        appearance: none;
        outline: none;
        text-transform: none;
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
        padding: 0;
        border: 0;
        border-radius: 2px;
        cursor: pointer;
    }

    .catalog-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        height: 52px;
        padding: 12px 16px;
        background: #333;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.5;
    }

    .empty-list-msg{
        display:flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        min-height: 50vh;
        width:100%;

        h2 {
            width: 100%;
            text-align: center;
            margin: 0 0 1.5rem 0;
            font-size: 1.5rem;
        }

        .catalog-button{
            font-size: 1.25rem;
            font-weight: 500;
            border-radius: 1.25rem;
            padding: .75rem 2rem;
        }
    }

    .prz-blk-product-likes-icon i{
        width: auto;
    }
}
</style>